import { CommandAlkonConnection_Read } from '@treadinc/horizon-api-spec';

export class CommandAlkonConnection {
  constructor(
    private _id: string,
    private _entity_ref: string,
    private _client_id: string,
    private _api_scope_ref: string,
    private _client_secret_last_four: string,
    private _api_key_last_four: string,
  ) {}

  public get id() {
    return this._id;
  }

  public get entityRef() {
    return this._entity_ref;
  }

  public get clientId() {
    return this._client_id;
  }

  public get apiScopeRef() {
    return this._api_scope_ref;
  }

  public get clientSecretLastFour() {
    return this._client_secret_last_four;
  }

  public get apiKeyLastFour() {
    return this._api_key_last_four;
  }

  public static parse(proto: CommandAlkonConnection_Read) {
    return new CommandAlkonConnection(
      proto.id,
      proto.entity_ref,
      proto.client_id,
      proto.api_scope_ref,
      proto.client_secret_last_four,
      proto.api_key_last_four,
    );
  }
}
